import { Link } from "react-router-dom";

export default function TreatmentPriceLink({
  categoryId,
  categoryJp,
  label = "料金表を見る",
}: {
  categoryId: string;
  categoryJp: string;
  label?: string;
}) {
  return (
    <div className="flex flex-col gap-7 border border-foreground-950/12 bg-background-50 p-8 md:flex-row md:items-center md:justify-between md:p-10">
      <div>
        <span className="en-eyebrow text-[10px] text-secondary-700 md:text-[11px]">PRICE</span>
        <p className="mt-4 font-heading text-[17px] leading-[1.8] text-foreground-900 md:text-lg">
          {categoryJp}の料金は、料金表ページでご確認いただけます。
        </p>
        <p className="mt-3 text-[12.5px] leading-[2] text-foreground-600">
          表示価格はすべて税込です。複数回のコース料金は、対面カウンセリングにてご案内しています。
        </p>
      </div>
      <Link
        to={`/price?tab=${categoryId}`}
        className="group inline-flex shrink-0 items-center justify-center gap-3 whitespace-nowrap rounded-md bg-primary-600 px-8 py-3.5 text-[14px] font-medium text-background-50 transition-colors hover:bg-primary-700"
      >
        {label}
        <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden />
      </Link>
    </div>
  );
}